import React, {Component} from 'react'

import {Container,Card,CardBody,Media} from 'reactstrap'

class Contact extends Component{

    render(){
        return(
            <div>
            <main>
            <section className="section-profile-cover section-shaped bg-light" >
                    
            <Container className="py-2 px-2">
            <header className="pt-2 pb-2"> <h2> Contact Us </h2></header>
            <hr/>

            <Card className="flex ">
                <CardBody>
                    <h2> Contact Details </h2>

                    <Media>  3481 Melrose Place 
                    Beverly Hills, CA 90210 
                     </Media>
                    <Media> <b> Email : </b> name@example.com

                    </Media>
                    <Media> <b> Phone : </b> (123) 456-7890  </Media>
                    <Media> <b> Timing : </b> Monday - Friday: 9:00 AM to 5:00 PM </Media>
                </CardBody>
                </Card>
                    </Container>
            </section>
            </main>
            </div>
        )
    }

}

export default Contact


// WEBPACK FOOTER //
// ./src/pages/Contact.js